import React, { useState, useEffect } from "react";
import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import app from "../../firebaseConfig";

const db = getFirestore(app);
const storage = getStorage(app);

const BackgroundAdmin = () => {
  const [currentPicture, setCurrentPicture] = useState("");
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);

  // Fetch the current background once on mount
  useEffect(() => {
    const fetchBackground = async () => {
      try {
        const docRef = doc(db, "background", "1");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data.picture) {
            setCurrentPicture(data.picture);
          }
        }
      } catch (error) {
        console.error("Error fetching background:", error);
      }
    };
    fetchBackground();
  }, []);

  // Handle file selection
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  // Upload file to Firebase Storage and update Firestore doc
  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      alert("Please choose an image file first.");
      return;
    }

    try {
      // Create a storage reference (e.g., 'backgrounds/background-1.png')
      const storageRef = ref(storage, `backgrounds/background-1-${Date.now()}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      // Track upload progress
      uploadTask.on("state_changed",
        (snapshot) => {
          // Calculate progress percentage
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress(Math.round(progress));
        },
        (error) => {
          console.error("Error uploading file:", error);
          alert("File upload failed.");
        },
        async () => {
          // On successful upload, get the download URL
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);

          // Update the doc with the new picture URL
          const docRef = doc(db, "background", "1");
          await updateDoc(docRef, {
            backgroundID: 1,
            picture: downloadURL,
          });

          setCurrentPicture(downloadURL);
          setFile(null);
          setUploadProgress(0);
          alert("Background updated successfully!");
        }
      );
    } catch (error) {
      console.error("Error uploading image or updating background:", error);
      alert("Failed to update background.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#121212", // Dark background
        color: "#fff",              // Light text
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "500px",
          width: "90%",
          backgroundColor: "#1e1e1e", // Another shade of dark
          borderRadius: "8px",
          padding: "20px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.5)",
        }}
      >
        <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
          Update Background
        </h2>

        {/* Display current background if it exists */}
        {currentPicture ? (
          <div style={{ marginBottom: "20px", textAlign: "center" }}>
            <p style={{ marginBottom: "10px" }}>Current Background:</p>
            <img
              src={currentPicture}
              alt="Current Background"
              style={{
                maxWidth: "100%",
                borderRadius: "5px",
                border: "1px solid #333",
              }}
            />
          </div>
        ) : (
          <p style={{ textAlign: "center", marginBottom: "20px" }}>
            No background set.
          </p>
        )}

        <form onSubmit={handleUpload}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontWeight: "bold",
            }}
          >
            Choose Image File
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ marginBottom: "15px" }}
          />

          {/* Progress bar (if uploading) */}
          {uploadProgress > 0 && (
            <div
              style={{
                width: "100%",
                backgroundColor: "#333",
                height: "10px",
                borderRadius: "5px",
                marginBottom: "15px",
              }}
            >
              <div
                style={{
                  width: `${uploadProgress}%`,
                  height: "100%",
                  backgroundColor: "#007bff",
                  transition: "width 0.3s ease",
                }}
              />
            </div>
          )}

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              fontWeight: "bold",
              borderRadius: "5px",
              border: "none",
              color: "#fff",
              backgroundColor: "#007bff",
              cursor: "pointer",
            }}
          >
            {uploadProgress > 0 ? "Uploading..." : "Upload New Background"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BackgroundAdmin;
